import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { CalendarDays, Ticket as TicketIcon } from "lucide-react";
import { api } from "./api";
import { useAuth } from "./AuthContext";

const fmtDate = (d) => { try { return new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return d; } };

export function TicketsPage() {
  const { user } = useAuth();
  const [tickets, setTickets] = useState(null);
  useEffect(() => { if (user) api.get("/tickets/mine").then((r) => setTickets(r.data)).catch(() => setTickets([])); }, [user]);

  if (!user) return (
    <div className="py-16 text-center">
      <TicketIcon size={30} className="mx-auto text-gold" />
      <p className="mt-4 font-oswald text-2xl uppercase tracking-tight">Sign in to see your tickets</p>
      <Link to="/login" data-testid="tickets-login" className="mt-6 inline-block bg-gold px-6 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-ink-950">Log In</Link>
    </div>
  );

  return (
    <div>
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ Your Passes</p>
      <h1 className="mt-3 mb-8 font-oswald text-5xl font-700 uppercase leading-[0.85] tracking-tighter">Tickets</h1>
      {tickets === null && <p className="text-zinc-500">Loading…</p>}
      {tickets?.length === 0 && <p className="text-zinc-500">No tickets yet. Grab some from Events!</p>}
      <div className="grid gap-5">
        {tickets?.map((t) => (
          <div key={t.id} data-testid={`ticket-${t.id}`} className="overflow-hidden border border-white/10 bg-ink-900/60">
            <div className="flex items-center justify-between border-b border-dashed border-white/15 px-5 py-4">
              <div>
                <h3 className="font-oswald text-xl font-600 uppercase tracking-tight">{t.event_title}</h3>
                <span className="flex items-center gap-1.5 text-sm text-zinc-400"><CalendarDays size={13} className="text-gold" /> {fmtDate(t.event_date)}</span>
              </div>
              <span className={`font-mono text-[10px] uppercase tracking-[0.2em] ${t.status === "used" ? "text-zinc-500" : "text-gold"}`}>
                {t.status === "used" ? "Used" : t.ticket_name}
              </span>
            </div>
            <div className="flex flex-col items-center gap-3 p-6">
              <div className={`bg-white p-3 ${t.status === "used" ? "opacity-40" : ""}`}>
                <QRCodeCanvas value={t.code} size={168} />
              </div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Show at the door · {t.code.slice(0, 8)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
